module.exports = __webpack_public_path__ + "media/images/lp/industries/mv-results-8753332b105e968c6b43c4eb9a1fa0de.svg";